import React from 'react';
import { Card, CardBody } from '@heroui/react';
import { TSummary } from '../valueTypes';

type SummaryProps = {
	summary: TSummary;
};

type SummaryItemProps = {
	label: string;
	value: string;
	prefix?: string;
	suffix?: string;
};

const SummaryItem: React.FC<SummaryItemProps> = ({ label, value, prefix = '', suffix = '' }) => {
	const isValueExists = value && value !== '-';

	return (
		<div className="space-y-4">
			<h3 className="font-semibold text-sm">{label}:</h3>
			<hr className="border-2 border-white" />
			<p className="text-lg">
				<span className="font-bold text-6xl">{isValueExists ? `${prefix}${value}` : '-'}</span>
				{isValueExists && <span className="text-sm"> {suffix}</span>}
			</p>
			<hr className="border border-dotted" />
		</div>
	);
};

const VesselSummary: React.FC<SummaryProps> = ({
	summary = { age: '', fairMarketValue: '', newbuildingContractPrice: '', scrapValue: '', infoNote: '' },
}) => {
	return (
		<Card className="bg-msi-darkblue-color text-white p-2 h-full shadow-none border border-msi-darkgrey-color-300 rounded">
			<CardBody>
				<div className="grid grid-cols-2 gap-6 h-full">
					<SummaryItem label="Age" value={summary.age.toString()} suffix="Years" />
					<SummaryItem label="Fair Market Value" value={summary.fairMarketValue} suffix="Mn" prefix="$" />
					<SummaryItem label="Newbuild Replacement Cost" value={summary.newbuildingContractPrice} prefix="$" suffix="Mn" />
					<SummaryItem label="Scrap Value" value={summary.scrapValue} prefix="$" suffix="Mn" />
				</div>
				<div className="mt-2 text-right">
					<h4 className="font-semibold">{summary.infoNote}</h4>
				</div>
			</CardBody>
		</Card>
	);
};

export default VesselSummary;
